import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './CustomFalseCeiling.module.scss';
import { FalseCeilingPlanTabs } from './CustomFalseCeilingConstants';
import TabViewSection from "./CustomTabViewSection";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";

const CustomFalseCeilingPlan = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);

  useEffect(() => {
    const pageData = {
      ...pageDetails,
      metaData: {
        ...pageDetails.metaData,
        horizontal_panel: pageDetails.metaData?.horizontal_panel || pageDetails?.quantityDetails?.horizontal_panel,
        vertical_panel: pageDetails.metaData?.vertical_panel || pageDetails?.quantityDetails?.vertical_panel,
        vertical_with_cove: pageDetails.metaData?.vertical_with_cove || pageDetails?.quantityDetails?.vertical_with_cove
      }
    };
    setUpdatedValues(pageData);

  }, [pageDetails]);

  return (
    <section className={style.ceiling_plan_section}>
      <h4 className="section_heading">2. False Ceiling Plan</h4>
      <div className={style.ceiling_plan_container}>
        <div className={style.false_ceiling_overview}>
          <div className={style.rightSection_tab}>
            <TabViewSection details={FalseCeilingPlanTabs.rightBar} index={1} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} />
          </div>
        </div>
        <div className={style.reflected_plan}>
          <h4 className="sub_tab_heading">Reflected Ceiling Plan</h4>
          <div className={style.canvas_height}>
            {
              pageDetails.images?.[0]?.imageUrl ? <div className={style.image_container}><img crossOrigin="anonymous" alt="Reflected ceiling plan" src={pageDetails.images?.[0]?.imageUrl} className="image-view" /></div> :
                <div className={style.canvas_view_description}>
                  <h4 className={style.canvas_view_heading}>Reflected Ceiling Plan of False Ceiling showing Lights, Fan, AC, AC Cutouts seen</h4>
                  <div className={style.canvas_view_details}>
                    <p className={style.canvas_view_details_head}>Mandatory Details :</p>
                    <ul className={style.canvas_view_details_listing}>
                      <li>Overall room dimensions in plan with correct AC Type, AC Size and AC Position AC Cut outs; Height of fire hydrant line / sprinklers from true ceiling </li>
                      <li>Woodwork that touches false ceiling should be highlighted in dotted line / colour</li>
                      <li>Drop height from true ceiling;</li>
                      <li>Dimensions of Horizontal panels along X-Axis & Y-Axis;</li>
                      <li>Dimensions of Verticals / Verticals with Cove / Rafters in length</li>
                      <li>Unique color coding / representations for different types of lights with Legend</li>
                    </ul>
                  </div>
                </div>
            }
          </div>
          <div className={style.rightSection_tab}>
            <h4 className="sub_tab_heading">Lighting Details</h4>
          </div>
        </div>
      </div>
      {/* <div className={style.footer_tab_view}>
        {
          FalseCeilingPlanTabs?.leftBar?.map((e: any, i: any) => <div className={style.border_right}><TabViewSection details={e} index={i} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} /></div>)
        }
      </div> */}
    </section>
  )
}

export default CustomFalseCeilingPlan;